module.exports = __webpack_public_path__ + "img/sec1_12.6bccc463.png";